import React from "react";
import useCeo from "../../hooks/useCEO";
import { ListadoUnidades } from "../../components/ProgramarSalida/ListadoUnidades";

export const ProgramarSalida = () => {
  useCeo({
    title: "Programar Salida",
    description: "Página de programar salida",
  });

  return (
    <>
      <div className="row">
        <div className="col-12 px-0 pt-2">
          <ListadoUnidades busqueda={1}></ListadoUnidades>
        </div>
      </div>
    </>
  );
};
